import { icSearch } from '@vivareal/lina-icons'

export default {
  name: 'oz-listing-code',

  props: {
    title: { type: String, required: true },
    externalId: { type: String },
  },

  data () {
    return {
      newExternalId: '',
    }
  },

  created () {
    this.newExternalId = this.externalId
  },

  computed: {
    icon () {
      return icSearch
    },
  },

  methods: {
    onInput (newExternalId) {
      this.newExternalId = newExternalId
    },

    updateFilter () {
      this.$emit('filters:update', { externalId: this.newExternalId })
    },
  },
}
